export const SET_VERSION = 'SET_VERSION';
export const SET_BANNER = 'SET_BANNER';
export const SET_PLAYER_READY = 'SET_PLAYER_READY';
export const SET_BANNER_ERRORINFO = 'SET_BANNER_ERRORINFO';

export const FETCH_BANNER = 'FETCH_BANNER';
